const TOKEN_KEY = 'token'
const REFRESH_TOKEN_KEY = 'refresh_token'

export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY)
}

export const setToken = token => {
  return localStorage.setItem(TOKEN_KEY, token)
}

export const removeToken = () => {
  return localStorage.removeItem(TOKEN_KEY)
}

export const getRefreshToken = () => {
  return localStorage.getItem(REFRESH_TOKEN_KEY)
}

export const setRefreshToken = refreshToken => {
  return localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken)
}

export const removeRefreshToken = () => {
  return localStorage.removeItem(REFRESH_TOKEN_KEY)
}
